export default {
    props: {
        sortableAllowUnsort: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.allowUnsort'
        }, 
        sortableShowIndexes: {
            type: Boolean,
            default: undefined,
            kComposite: 'sortable.showIndexes'
        }, 
        sortableInitialDirection: {
            type: String,
            default: undefined,
            kComposite: 'sortable.initialDirection'
        }, 
        sortableMode: {
            type: String,
            default: undefined,
            kComposite: 'sortable.mode'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Sortable.js